<template>
  <select class="lang-selector bg-transparent text-white outline-none noselect" v-model="selectedLocale">
    <option v-for="locale in $i18n.availableLocales" :key="locale" :value="locale">
      {{ locale.toUpperCase() }}
    </option>
  </select>
</template>

<script>
export default {
  name: "LangSelector",
  data() {
    return {
      selectedLocale: this.$i18n.locale,
    };
  },
  methods: {
    setLanguagePreference(newLocale) {
      this.$nextTick(() => {
        this.$store.dispatch("setLanguagePreference", newLocale);
      });
    },
  },
  watch: {
    selectedLocale(newLocale) {
      console.log("newLocale");
      console.log(newLocale);
      this.$i18n.locale = newLocale;
      this.setLanguagePreference(newLocale);
      // this.$store.dispatch("setLanguagePreference", newLocale);
    },
    '$store.getters.selectedLanguage': {
      immediate: true,
      handler(newLocale) {
        if (this.selectedLocale != newLocale)
          this.selectedLocale = newLocale;

      }
    }
  },
};
</script>

<style lang="scss">
.lang-selector {
  option {
    color: black;
    font-size: 14px;
  }
}
</style>
